var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.comprobantesConsultados,
                    expression: "!comprobantesConsultados"
                  }
                ],
                staticClass: "btn-info btn--bigger",
                on: { click: _vm.consultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.comprobantesConsultados,
                    expression: "comprobantesConsultados"
                  }
                ],
                staticClass: "btn-danger btn--bigger",
                on: { click: _vm.cancelar }
              },
              [
                _c("i", { staticClass: "fa fa-ban" }),
                _vm._v(" "),
                _c("span", [_vm._v("Cancelar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.comprobantesConsultados,
                    expression: "comprobantesConsultados"
                  }
                ],
                staticClass: "btn-success btn--bigger",
                on: { click: _vm.cerrar }
              },
              [
                _c("i", { staticClass: "fa fa-times" }),
                _vm._v(" "),
                _c("span", [_vm._v("Cerrar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-primary btn--bigger",
                on: { click: _vm.consultarCierres }
              },
              [
                _c("i", { staticClass: "fa fa-table" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar cierres de conciliación")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        disabled: _vm.comprobantesConsultados,
                        id: "fecha_inicial",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "auto-close": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione una fecha..."
                      },
                      model: {
                        value: _vm.form.fecha_inicial,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_inicial", $$v)
                        },
                        expression: "form.fecha_inicial"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha inicial")]),
                    _vm._v(" "),
                    _vm.errores.fecha_inicial
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.fecha_inicial[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c("div", { staticClass: "form-field" }, [
                _c(
                  "div",
                  { staticClass: "datepicker-field" },
                  [
                    _c("VueCtkDateTimePicker", {
                      attrs: {
                        disabled: _vm.comprobantesConsultados,
                        id: "fecha_final",
                        locale: "es",
                        "no-label": "",
                        "only-date": "",
                        "auto-close": "",
                        "button-now-translation": "Ahora",
                        format: "YYYY-MM-DD",
                        formatted: "YYYY-MM-DD",
                        label: "Seleccione una fecha..."
                      },
                      model: {
                        value: _vm.form.fecha_final,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "fecha_final", $$v)
                        },
                        expression: "form.fecha_final"
                      }
                    }),
                    _vm._v(" "),
                    _c("label", [_vm._v("Fecha final")]),
                    _vm._v(" "),
                    _vm.errores.fecha_final
                      ? _c(
                          "span",
                          {
                            staticClass: "helper-text text-danger",
                            attrs: { slot: "helper" },
                            slot: "helper"
                          },
                          [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.errores.fecha_final[0]))
                            ])
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-4" }, [
              _c(
                "div",
                {
                  staticClass: "form-field select2",
                  class: {
                    "select2--disabled": _vm.comprobantesConsultados
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "select2-field" },
                    [
                      _c("v-select", {
                        attrs: {
                          placeholder: "Seleccione los vendedores...",
                          id: "vendedores",
                          options: _vm.vendedores,
                          label: "nombre_usuario",
                          multiple: ""
                        },
                        on: { input: _vm.inputVendedores },
                        model: {
                          value: _vm.selectedVendedores,
                          callback: function($$v) {
                            _vm.selectedVendedores = $$v
                          },
                          expression: "selectedVendedores"
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "vendedores" } }, [
                        _vm._v("Vendedor(es)")
                      ]),
                      _vm._v(" "),
                      _vm.errores.vendedores
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.vendedores[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12 col-md-6" }, [
              _c(
                "div",
                { staticClass: "form-field" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        placeholder: "Escriba una observación...",
                        id: "observacion"
                      },
                      model: {
                        value: _vm.formSubmit.observacion,
                        callback: function($$v) {
                          _vm.$set(_vm.formSubmit, "observacion", $$v)
                        },
                        expression: "formSubmit.observacion"
                      }
                    },
                    [
                      _vm._v("\n              Observación\n              "),
                      _vm.errores.observacion
                        ? _c(
                            "span",
                            {
                              staticClass: "helper-text text-danger",
                              attrs: { slot: "helper" },
                              slot: "helper"
                            },
                            [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.errores.observacion[0]))
                              ])
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.comprobantesAgrupados, function(comprobanteAgrupado, index) {
        return _c(
          "div",
          { key: index + comprobanteAgrupado.title, staticClass: "row mt-2" },
          [
            _c(
              "div",
              { staticClass: "col-xs-12" },
              [
                _c("item-cierre-comisiones", {
                  attrs: {
                    permiteEditarComision: _vm.permiteEditarComision,
                    vendedores: _vm.vendedores,
                    index: index,
                    errores: _vm.errores,
                    saldo_anterior: _vm.obtenerSaldoAnterior(
                      _vm.comprobantesAgrupados[index].vendedor_id
                    ),
                    porcentaje_comision: _vm.formSubmit.porcentaje_comision,
                    comision_base: _vm.formSubmit.comision_base
                  },
                  on: { vendedorCambiado: _vm.consultar },
                  model: {
                    value: _vm.comprobantesAgrupados[index],
                    callback: function($$v) {
                      _vm.$set(_vm.comprobantesAgrupados, index, $$v)
                    },
                    expression: "comprobantesAgrupados[index]"
                  }
                })
              ],
              1
            )
          ]
        )
      }),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _c("div", { staticClass: "card__content" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("div", { staticClass: "table-responsive" }, [
                _c("table", [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.margenTotal)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.moneyFormat(_vm.formSubmit.comision_base))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            _vm.decimalFormat(
                              _vm.formSubmit.porcentaje_comision
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.moneyFormat(_vm.comisionTotal)))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Cierre de Comisiones")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card__title" }, [
      _c("h3", [_vm._v("Información de cierre")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Margen total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Base")]),
        _vm._v(" "),
        _c("th", [_vm._v("Porc. Comisión")]),
        _vm._v(" "),
        _c("th", [_vm._v("Comisión total")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-45293305", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45293305","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/cierre-comisiones/CierreComisiones.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-45293305","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/cierre-comisiones/CierreComisiones.vue
// module chunks = 0